angular.module('unica_campaign.campaign_services')

.factory('CampaignSendService', function($http, getBaseApiURL) {

	var campaignSendService = {};

	campaignSendService.send = function( campaignId) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign/send/' + campaignId ,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	return campaignSendService;

});